/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useRef, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getToken, withAppContext } from '@ctsu/loader';
import { GridTable, GridController } from '@ctsu/ctsu-mui-grid';
import bindLogger from 'helpers/BindLogger';
import { RenderElement } from 'components/RenderHelpers';
import { openConfirmation } from 'components/Confirmation/Confirmation';
import { ATCONSTANTS as ATC } from 'appconstants';
import ModalFooter from 'components/ModalFooter/ModalFooter';
import {
  createSR, saveIndexing, getIndexing, deleteIndexingRowApi, generateProcess
} from 'actions/packet';
import { getSiteRegDetails } from 'actions/siteregistration';
import { getProtocolDetails } from 'actions/cirb';
import { CanUserEditIndex, CanUserCreateSR, CanUserEditIRB } from 'appconstants/Permission';
import {
  doPassThrough, getEncodedQueryParams, getExportTitle, showErrorNotification, showSuccessNotification
} from 'helpers';
import { FasExclamationTriangle } from 'assets/icons';
import { faSyncAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getIndexingColumns from './Column';
import QuickIndexing from './QuickIndexing';
import IndexingEditRow from './IndexingEditRow';
import { onClickIrbButton, onClickSRButton, openIRBWindow } from './LinkingButtonActions';

const indexingGridContrller = GridController.createController();

function CreateSRPopupContent() {
  return (
    <div>
      Are you sure you want to generate these Site Registration records (This will also save any pending changes)?
    </div>
  );
}

function DeletePopupContent({ displayConfirmationMessage, row }) {
  const confirmMessage = `Are you sure you want to delete the record for ${displayConfirmationMessage(row)}`;
  return <div>{`${confirmMessage}?`}</div>;
}

function Indexing({
  packet,
  controller,
  indexingRows,
  context,
  allowEditing,
  setIsChildEdit,
  setPrevSelectedIndex,
  selectedGridIndex,
  ...props
}) {
  const { session } = context;
  const { object, packetId, lockedBy } = packet;
  const [columns, setColumns] = useState([]);
  const [rowEditing, setRowEditing] = useState(false);
  const [page, setPage] = useState(0);
  const [selectedIndex, setSelectedindex] = useState(0);
  const [isSRdEditing, setIsSRdEditing] = useState(false);

  let setIsGridEditing;
  let modal;
  const editIndexingRef = useRef();
  const cancelEdit = () => {
    if (setIsGridEditing) {
      setIsGridEditing(false);
    }
    setIsChildEdit(false);
    setRowEditing(false);
    editIndexingRef.current = null;
  };

  const temp = getIndexingColumns(object).filter((c) => !c.isVisible || c.isVisible());
  useEffect(() => {
    setColumns(temp);
    /* adding temp to the dependecny array breaking the indexing grid. */
    // eslint-disable-next-line
  }, [object]);

  const reload = () => bindLogger(props.getIndexing, context)(packetId, object);

  const onClickCreateSR = (isButtonClick) => {
    function onAction() {
      bindLogger(props.generateProcess, context)(packetId, object, 'error')
        .subscribe((resp) => {
          if (resp === 'SUCCESS') {
            modal.handleClose();
            cancelEdit();
            controller.filterExternally(props.appliedFilters, false, false);
            showSuccessNotification(`${packetId} - SRs Generated successfully.`);
          }
        });
    }

    if (rowEditing && isButtonClick) {
      // eslint-disable-next-line no-unused-expressions
      editIndexingRef.current && editIndexingRef.current.triggerSave();
      return;
    }

    if (!rowEditing) {
      editIndexingRef.current = null;
    }

    const onCancel = () => {
      modal.handleClose();
    };
    const onProcess = () => {
      onAction();
      modal.handleClose();
    };
    modal = openConfirmation({
      header: 'Create SR',
      modalFooter: (
        <ModalFooter
          firstBtnName="Confirm"
          secondBtnName="Close"
          frstDataId={`${ATC.PACKETID}INDEXING_CONFIRM${ATC.BUTTON}`}
          secondDataId={`${ATC.PACKETID}INDEXING_CLOSE${ATC.BUTTON}`}
          firstBtnHandler={onProcess}
          secondBtnHandler={onCancel}
        />
      ),
      renderComp: () => <CreateSRPopupContent />,
      isClose: false
    });
  };

  const onClickQuickIndexing = () => {
    let indexRows = [];
    const setRows = (rows) => {
      indexRows = [...rows];
    };
    let confirmationBox;
    const onSaveQI = () => {
      bindLogger(props.saveIndexing, context)(packetId, object, indexRows).subscribe(() => {
        confirmationBox.close();

        showSuccessNotification('Save successful.');
        reload();
      });
    };
    confirmationBox = openConfirmation({
      header: 'Quick Indexing',
      renderComp: () => (
        <QuickIndexing
          context={context}
          indexingRows={indexingRows}
          packet={packet}
          setIndexRows={setRows}
          onSaveQI={onSaveQI}
        />
      ),
      isClose: false
    });
  };

  const isCreateSrDisabled = (lockedByV, isSRYes) => {
    if (rowEditing) {
      return false;
    }
    return isSRYes || !(lockedByV != null && lockedByV === session.username);
  };

  const getBtnClasses = (lockedByVal, isSRd) => {
    let classesName = 'btn turquoise mr-1';

    if (lockedByVal != null && lockedByVal === session.username) {
      if (isSRd) {
        if (rowEditing) {
          if (!isSRdEditing) {
            classesName += ' btn-red';
          }
        } else {
          classesName += ' btn-red';
        }
      }
    }
    return classesName;
  };

  const customHeaderIcons = () => {
    if (object === 'SITE_REGISTRATION') {
      const isSRd = indexingRows.some((row) => row.isSR === false);
      const isSRYes = indexingRows.every((row) => row.isSR === true);
      return (
        <>
          {lockedBy != null && lockedBy === session.username ? (
            <RenderElement access={CanUserEditIndex()}>
              <button
                data-id={`${ATC.PACKETID}QUICK_INDEXING${ATC.BUTTON}`}
                className="btn turquoise mr-1"
                type="button"
                onClick={onClickQuickIndexing}
              >
                Quick Indexing
              </button>
            </RenderElement>
          ) : null}
          <RenderElement access={CanUserCreateSR()}>
            <span
              className="cssjs-tooltip"
              title={isSRd ? 'There are unprocessed SR records' : 'All records are processed'}
            >
              <button
                data-id={`${ATC.PACKETID}CREATE_SR${ATC.BUTTON}`}
                className={getBtnClasses(lockedBy, isSRd)}
                type="button"
                onClick={() => onClickCreateSR(true)}
                disabled={isCreateSrDisabled(lockedBy, isSRYes)}
              >
                <div className="row align-items-center">
                  <span>
                    {isSRd ? (
                      <FasExclamationTriangle
                        className="ml-1 mr-0"
                        title="You have made changes to the Indexing section of this packet and have not yet processed those changes. Please click the Create SRs button or delete your added Indexing row(s)"
                      />
                    ) : null}
                    &nbsp;Create SRs
                  </span>
                </div>
              </button>
            </span>
          </RenderElement>
          <button
            type="button"
            data-id={`${ATC.PACKETID}INDEXING_REFRESH${ATC.BUTTON}`}
            onClick={() => {
              reload();
            }}
            className="fn-btn turquoise mr-1"
            title="Refresh Grid"
          >
            <FontAwesomeIcon icon={faSyncAlt} />
          </button>
        </>
      );
    }
    return (
      <button
        type="button"
        data-id={`${ATC.PACKETID}INDEXING_REFRESH${ATC.BUTTON}`}
        onClick={() => {
          reload();
        }}
        className="fn-btn turquoise mr-1"
        title="Refresh Grid"
      >
        <FontAwesomeIcon icon={faSyncAlt} />
      </button>
    );
  };

  const displayMessage = (mObject, message) => {
    const { siteCtepId, personCtepId, patientId } = mObject;
    let messagetoDisplay = message;
    if (siteCtepId) {
      messagetoDisplay = `${siteCtepId} - ${message}`;
    } else if (personCtepId) {
      messagetoDisplay = `${personCtepId} - ${message}`;
    } else if (patientId) {
      messagetoDisplay = `${patientId} - ${message}`;
    }
    return messagetoDisplay;
  };

  const getConfirmationMsg = (id, val, boolVal) => {
    const text = boolVal ? id || val : id;
    return id && val ? `${id} / ${val}` : text;
  };

  const displayConfirmationMessage = (mObject) => {
    const {
      siteCtepId, personCtepId, patientId, protocolNumber, objKeyValue, objType
    } = mObject;
    let messagetoDisplay = '';
    if (objType === 'MEMBERSHIP' || objType === 'INSTITUTION') {
      messagetoDisplay = getConfirmationMsg(siteCtepId, objKeyValue, false);
    } else if (objType === 'SITE_REGISTRATION' || objType === 'PAPER_CRFS_QUERIES') {
      messagetoDisplay = getConfirmationMsg(siteCtepId, protocolNumber, true);
    } else if (objType === 'PERSON') {
      messagetoDisplay = getConfirmationMsg(personCtepId, objKeyValue, false);
    } else if (objType === 'ENROLLMENT_TRANSFERS') {
      messagetoDisplay = getConfirmationMsg(patientId, protocolNumber, false);
    }
    return messagetoDisplay;
  };

  const onDelete = (row) => {
    const { dmsPktMapId, objType } = row;
    /**
     * removed if condition due to UAT feedback #18
     * @see {@link https://confluence.ctsu.org/display/REG/User+Acceptance+Testing+Scenarios | Confluence}
     */
    const onAction = () => {
      bindLogger(props.deleteIndexingRowApi, context)(dmsPktMapId, objType).subscribe(
        () => {
          showSuccessNotification(displayMessage(row, 'Deleted Successfully'));
          props.rowClick(packet, props.selectedIndex);
          indexingGridContrller.reload();
        },
        () => {
          showErrorNotification('Unable to delete the row.');
        }
      );
    };
    const onCancel = () => {
      modal.handleClose();
    };
    const onProcess = () => {
      onAction();
      modal.handleClose();
    };
    modal = openConfirmation({
      header: 'Confirm Deletion',
      modalFooter: (
        <ModalFooter
          firstBtnName="Confirm"
          secondBtnName="Close"
          frstDataId={`${ATC.PACKETID}INDEXING_DELETE_CONFIRM${ATC.BUTTON}`}
          secondDataId={`${ATC.PACKETID}INDEXING_DELETE_CLOSE${ATC.BUTTON}`}
          firstBtnHandler={onProcess}
          secondBtnHandler={onCancel}
        />
      ),
      renderComp: () => <DeletePopupContent displayConfirmationMessage={displayConfirmationMessage} row={row} />,
      modalSize: 'sm',
      isClose: false
    });
  };

  const onClickHistory = (row) => {
    const { siteCtepId, protocolNumber, siteName } = row;
    if (siteCtepId && protocolNumber) {
      const encodedPath = getEncodedQueryParams('/packet/packet-history', `instName=${siteName}&instId=${siteCtepId}&protNum=${protocolNumber}`);
      window.open(encodedPath, '_blank');
    } else {
      openConfirmation({
        header: 'Packet History Warning',
        message:
          'You need to enter both Institution CTEP ID and Protocol Number to see the Packet History of an Indexing record.',
        isClose: true
      });
    }
  };

  const onClickGo = (row) => {
    if (row.objType === 'INSTITUTION') {
      const encodedParams = getEncodedQueryParams('institution/roster/attributes', `ctepid=${row.siteCtepId}`);
      doPassThrough('ROSTERING', encodedParams);
    } else {
      const encodeParams = getEncodedQueryParams('person/roster/attributes', `ctepid=${row.personCtepId}`);
      doPassThrough('ROSTERING', encodeParams);
    }
  };

  const hasIrbEditAccess = CanUserEditIRB();

  const onClickChgPI = (row) => {
    const {
      siteCtepId: ctepId, protocolNumber, pktId, latestIrbId, siteName
    } = row;
    openIRBWindow(
      {
        ctepId, protocolNumber, pktId, id: latestIrbId, siteName, packetId, length: 1
      },
      hasIrbEditAccess,
      'packet_processing',
      true
    );
  };

  const onClickIrbAction = (row) => {
    const input = { ...row };
    input.packetId = packetId;
    onClickIrbButton(input, context, hasIrbEditAccess, 'packet_processing');
  };

  const onClickSRAction = (row) => {
    const input = { ...row };
    const rowIdx = indexingRows.findIndex((x) => x.dmsPktMapId === row.dmsPktMapId);
    input.packetId = packetId;
    input.idx = rowIdx;
    onClickSRButton(input);
  };

  const checkFields = ({ objType, personCtepId, objKeyValue }) => {
    let message = '';
    if (objType === 'PERSON') {
      if (!personCtepId) {
        message = 'Person CTEP ID field is mandatory.';
      } else if (!objKeyValue) {
        message = 'Attributes field is mandatory.';
      }
    } else if (objType === 'INSTITUTION') {
      if (!objKeyValue) {
        message = 'Attributes field is mandatory.';
      }
    } else if (objType === 'MEMBERSHIP') {
      if (!objKeyValue) {
        message = 'Document Type field is mandatory.';
      }
    }
    return message;
  };

  const onSave = (updatedRow, invokeProcess) => {
    const { dmsPktMapId } = updatedRow;
    const errorMessage = checkFields(updatedRow);
    if (errorMessage !== '') {
      showErrorNotification(errorMessage);
      return;
    }
    setIsChildEdit(false);
    bindLogger(props.saveIndexing, context)(packetId, object, [updatedRow]).subscribe(() => {
      showSuccessNotification(
        displayMessage(updatedRow, dmsPktMapId ? 'Updated successfully.' : 'Added successfully.')
      );
      cancelEdit();
      reload();
      if (invokeProcess) {
        if (object === 'SITE_REGISTRATION') {
          onClickCreateSR();
        }
      }
    });
  };

  const getEditRow = (row, changeGridEditing) => {
    // Workaround Fix!!
    // We do not any way to change the grid row editing outside the Edit Row Renderer.
    // Need a property to change row editing in the Grid Controller.
    setIsGridEditing = changeGridEditing;
    setRowEditing(true);
    setIsChildEdit(true);
    setPrevSelectedIndex(selectedGridIndex);
    setIsSRdEditing(!row.isSR);

    return (
      <IndexingEditRow
        ref={editIndexingRef}
        cancelEdit={cancelEdit}
        packet={packet}
        row={row}
        columns={columns}
        onClickSaveIcon={onSave}
        reload={reload}
        context={context}
      />
    );
  };
  const onRowClick = (row, index, meta, event, currentRowPage) => {
    setPage(currentRowPage);
    if (row != null) {
      setSelectedindex(index);
      indexingGridContrller.highlightRow(index);
    }
  };

  const onDataLoad = (data, currentPage) => {
    cancelEdit();
    if (page > 0) {
      indexingGridContrller.setPage(page > 0 && currentPage === 0 ? page : currentPage);
    }
    if (data != null && data.length > 0) {
      const index = data.length > selectedIndex && selectedIndex !== -1 ? selectedIndex : 0;
      onRowClick(data[index], index, {}, {}, 0);
    }
  };

  const onCopyRow = (row) => {
    const newRow = { ...row };
    delete newRow.dmsPktMapId;
    delete newRow.isSR;
    return newRow;
  };

  const isRowEditable = (row) => object !== 'SITE_REGISTRATION' || !row.isSR;
  const isRowDeletable = () => true;

  return (
    <GridTable
      tag={`${ATC.PACKETID}PROCESSING_INDEX${ATC.TABLE}`}
      id={`PacketProcessing${packetId}Indexing`}
      key={`PacketProcessing${packetId}IndexingKey`}
      rows={indexingRows}
      user={session.username}
      rowEvents={[onClickGo, onClickHistory, onClickSRAction, onClickIrbAction, onClickChgPI]}
      title={(
        <span role="heading" aria-level="3">
          Indexing
        </span>
      )}
      columns={columns}
      controller={indexingGridContrller}
      recordPerPage={5}
      allowCopyRow={() => true}
      onCopy={onCopyRow}
      getToken={getToken}
      editable
      sortable
      editMode={allowEditing && CanUserEditIndex()}
      deletable
      allowAddRow={allowEditing && CanUserEditIndex()}
      rowEditable={isRowEditable}
      onDataLoad={onDataLoad}
      onRowClicked={onRowClick}
      rowDeletable={isRowDeletable}
      onDelete={onDelete}
      renderEditRow={getEditRow}
      showFilterByDefault
      enableToolbar
      rowsPerPageOptions={[5, 15, 20]}
      highlightRow={0}
      renderCustomHeaderIcons={customHeaderIcons}
      exportTitle={getExportTitle(`Indexing ${packetId}`)}
      toPdf={false}
      showAllRecords // --> enable after gird changes are deployed, -> used to show all the records initially
    />
  );
}

const mapStateToProps = (state) => ({
  indexingRows: state.packet.indexing || []
});

const withConnectState = connect(mapStateToProps, (dispatch) => bindActionCreators(
  {
    createSR,
    saveIndexing,
    getIndexing,
    generateProcess,
    deleteIndexingRowApi,
    getProtocolDetails,
    getSiteRegDetails
  },
  dispatch
));
export default withAppContext(withConnectState(Indexing));
